document.addEventListener("DOMContentLoaded", function () {
  const tabLinks = document.querySelectorAll(".needs-nav a");
  const tabContents = document.querySelectorAll(".needs-content");

  tabLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      tabLinks.forEach((l) => l.classList.remove("active"));
      tabContents.forEach((c) => (c.style.display = "none"));

      this.classList.add("active");
      // reload slider
      window.dispatchEvent(new Event('resize'));
      const target = document.querySelector(this.getAttribute("href"));
      if (target) target.style.display = "block";
    });
  });
});